module.exports = __webpack_public_path__ + "static/media/surfing.4c9714e4.webp";